/** Status → bar / legend colors for the vacation planner Gantt. */
export const STATUS_COLORS = {
  Pending: "#FCC94A",
  Aprovuar: "#1da193",
  Refuzuar: "#ea3943",
  Shtyre: "#6b8cae",
};

export const REQUEST_TYPE_COLORS = {
  Pushime: "#1da193",
  "Dite Personale": "#858585",
  "Leje lindje": "#DE8EBD",
};

export function colorForRequest(request, { now = Date.now() } = {}) {
  const end = request?.requestPeriod?.at?.(-1) ?? request?.requestPeriod?.slice(-1)?.[0];
  if (end != null && end < now) return "#6E7278";
  const status = request?.requestStatus;
  if (status && STATUS_COLORS[status]) return STATUS_COLORS[status];
  return REQUEST_TYPE_COLORS[request?.requestType] || "#ea3943";
}
